import { createContext, useContext } from "react";

import { Station, ViewMode } from "../types";

export type ActiveType = "radio" | "pods" | "curator" | "favs";

export interface CurrentContext {
  type: "grid" | "carousel" | "search" | "favorites" | "related" | "history";
  items: Station[];
  index: number;
}

interface AppContextType {
  currentStation: Station | null;
  isPlaying: boolean;
  isBuffering: boolean;
  playStation: (station: Station) => void;
  togglePlay: () => void;
  favorites: Station[];
  toggleFavorite: (station: Station) => void;
  activeType: ActiveType;
  setActiveType: (type: ActiveType) => void;
  viewMode: ViewMode; // Keeping for compatibility, though Router will take over
  setViewMode: (mode: ViewMode) => void;
  handleStationSelect: (station: Station) => void; // Centralized navigation/selection

  // Search & Data State
  stations: Station[];
  setStations: (stations: Station[]) => void;
  loadingStations: boolean;
  selectedCountry: string;
  setSelectedCountry: (country: string) => void;
  handleStationRequest: (criteria: {
    genre?: string;
    country?: string;
    mood?: string;
  }) => Promise<void>;
  currentContext: CurrentContext | null;
  setCurrentContext: (ctx: CurrentContext | null) => void;

  // Auth Gate
  triggerGate: (onContinue: () => void) => void;
  // Creator Mode State
  creatorTrack: { id: string; title?: string; url?: string } | null;
  isCreatorPlaying: boolean;
  // Player State
  currentTime: number;
  handleSeek: (time: number) => void;

  // UI Actions
  onOpenProfile: () => void;
}

export const AppContext = createContext<AppContextType | undefined>(undefined);

export const useApp = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error("useApp must be used within an AppContextProvider");
  }
  return context;
};
